/*** IMPORTS FROM imports-loader ***/
(function() {
var mp = window.mp;
var exports = undefined;
var define = undefined;
var module = undefined;

/* eslint camelcase: 0, no-var: 0 */
/* globals _, mp */

_.namespace(`mp.marketing.trends.reports`, function(ns) {
  'use strict';

  var old_models = [
    mp.marketing.trends.utils.IPHONE_12,
    mp.marketing.trends.utils.IPHONE_12_PRO,
    mp.marketing.trends.utils.IPHONE_12_PRO_MAX,
    mp.marketing.trends.utils.IPHONE_12_MINI,
    mp.marketing.trends.utils.OTHER_IPHONE,
  ];
  var release_models = [
    mp.marketing.trends.utils.IPHONE_13,
    mp.marketing.trends.utils.IPHONE_13_PRO,
    mp.marketing.trends.utils.IPHONE_13_PRO_MAX,
    mp.marketing.trends.utils.IPHONE_13_MINI,
  ];
  var IPhone13 = mp.marketing.trends.widgets.PhoneAdoption.extend({
    get_display_models() {
      return release_models.concat(old_models);
    },
    get_release_models() {
      return release_models;
    },
    get_visible_models() {
      return release_models.concat(old_models.slice(0, 3));
    },
    get_query_name() {
      return mp.marketing.trends.utils.IPHONE_QUERY;
    },
    getDownloadName() {
      return ns.IPhone13.nice_name;
    },
  });

  Object.assign(IPhone13, {
    slug: `iphone_13`,
    nice_name: `iPhone 13 adoption`,
    description: `How quickly will people start using the new iPhone 13 models?`,
  });
  ns.IPhone13 = IPhone13;
});

}.call(window));